module.exports = __webpack_public_path__ + "86dd4197bc664e69cc2dcba53bd2e6bc.woff2";